import { stringify } from "../../util/querystring-util";
import {
  GetIfConversionRulesRequest,
  GetIfConversionRulesResponse,
  UpdateIfConversionRulesRequest,
  UpdateIfConversionRulesResponse,
  DeleteIfConversionRulesRequest,
  DeleteIfConversionRulesResponse,
} from ".";
import { restResourceRequester } from "../rest-resource-requester";

interface IfConversionRulesRestResource {
  /**
   * GET /
   */
  getIfConversionRules(
    request: GetIfConversionRulesRequest,
  ): Promise<GetIfConversionRulesResponse>;

  /**
   * PUT /
   */
  updateIfConversionRules(
    request: UpdateIfConversionRulesRequest,
  ): Promise<UpdateIfConversionRulesResponse>;

  /**
   * DELETE /
   */
  deleteIfConversionRules(
    request: DeleteIfConversionRulesRequest,
  ): Promise<DeleteIfConversionRulesResponse>;
}

const REST_RESOURCE_NAME = "/if-conversion-rules";

/**
 * GET /if-conversion-rules
 */
const getIfConversionRules = restResourceRequester<
  GetIfConversionRulesRequest,
  GetIfConversionRulesResponse
>("GET", (request) => `${REST_RESOURCE_NAME}?${stringify(request)}`);

/**
 * PUT /if-conversion-rules
 */
const updateIfConversionRules = restResourceRequester<
  UpdateIfConversionRulesRequest,
  UpdateIfConversionRulesResponse
>(
  "PUT",
  (request) => REST_RESOURCE_NAME,
  (request) => JSON.stringify(request),
);

/**
 * DELETE /if-conversion-rules
 */
const deleteIfConversionRules = restResourceRequester<
  DeleteIfConversionRulesRequest,
  DeleteIfConversionRulesResponse
>(
  "DELETE",
  (request) => REST_RESOURCE_NAME,
  (request) => JSON.stringify(request),
);

export const ifConversionRulesRestResource: IfConversionRulesRestResource = {
  getIfConversionRules: getIfConversionRules,
  updateIfConversionRules: updateIfConversionRules,
  deleteIfConversionRules: deleteIfConversionRules,
};
